import styled from 'styled-components'

import { Header1 } from '@/components/Text.tsx'

export const Header = styled(Header1)`
  margin-bottom: 24px;
`
